import React from "react";

import { Link } from "react-router-dom";

import noImage from "../../assets/image_not_supported.svg";
import ReviewScore from "../global/review-score";
import SustainabilityScore from "../global/sustainability/Sustainability";

import NewToHippo from "../global/new-to-hippo";
import LikeProperty from "../global/like-property";
import StarRating from "../global/star-rating/StarRating";
import { replaceImageUrlSize } from "../../utils/image";
import GlobalImage from "../global/image/image";
import UserInputViewer from "../global/UserInputViewer";

const NotAvailablePropertyCard = ({ property = {} }) => {
  const propertyName = property?.name;

  const overallScore = property?.reviewSummary.overallScore;
  const reviewerCount = property?.reviewSummary.reviewerCount;

  const isNew = property?.isNewProperty;

  const showReviews = overallScore > 0 && reviewerCount > 0;

  const showNewTag = isNew && !showReviews;

  const viewPropertyURL = `/property/${property?.id}/${encodeURIComponent(propertyName)}`;

  return (
    <div className="property-card box-border exact-property-match">
      <div className="property-image">
        {property?.defaultImage ? (
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet={replaceImageUrlSize(property?.defaultImage, "medium")}
              alt="Building"
              className="building skeleton-loading"
            />
            <GlobalImage src={replaceImageUrlSize(property?.defaultImage, "square")} alt="Building" className="building " />
          </picture>
        ) : (
          <GlobalImage src={noImage} alt="Not Available" className="building" />
        )}

        <LikeProperty propertyId={property?.id} isLiked={property?.isLiked} />
      </div>

      <div className="property-card-info">
        <div className="property-info">
          <div className="prop-data">
            <h3>
              <UserInputViewer tag="Link" to={viewPropertyURL} className="view-details" text={propertyName} />
            </h3>
            <UserInputViewer tag="p" text={property?.fullAddress} />
            <StarRating rating={property?.rating} />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              alignItems: "flex-end",
            }}
          >
            {showReviews && <ReviewScore score={overallScore} totalReviews={reviewerCount} />}

            {showNewTag && <NewToHippo />}

            {/* <SustainabilityScore /> */}
          </div>
        </div>

        <div className="not-available-card">
          <p>This property is not available for the dates you’ve selected.</p>
          <Link
            aria-disabled="true"
            to={"/"}
            // className="btn see-more"
            className="global-button global-button--primary listing-card-button"
          >
            See available rooms
          </Link>

          <div className="property-card-sm-wrapper">
            {showReviews && <ReviewScore score={overallScore} totalReviews={reviewerCount} isRtl={false} />}

            {showNewTag && <NewToHippo />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotAvailablePropertyCard;
